import React, { FC } from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { Pickup } from 'types/pickup';

const labelProps = { fontSize: '14px', opacity: 0.6 };

export const GeneralInfo: FC<{ pickup?: Pickup }> = ({ pickup }) => {
  return (
    <Flex
      py="50px"
      direction="column"
      justify="center"
      align="center"
      fontWeight="600">
      <Flex direction="column" gap="40px" minW="300px">
        {/* Commented as it not needed. kept the commented code incase it needed in future */}
        {/* <Flex align="center" gap="5px">
          <Text {...labelProps}>Collection Point : </Text>
          <Text>{pickup?.collectionPoint?.name || ''}</Text>
        </Flex>

        <Flex align="center" gap="5px">
          <Text {...labelProps}>Pickup Date : </Text>
          <Text>{convertUTCToLocal(pickup?.date, true, true)}</Text>
        </Flex> */}

        <Flex align="center" gap="5px">
          <Text {...labelProps}>Event Name : </Text>
          <Text>{pickup?.eventName || ''}</Text>
        </Flex>

        <Flex align="center" gap="5px">
          <Text {...labelProps}>Notes : </Text>
          <Text>{pickup?.notes || ''}</Text>
        </Flex>

        <Flex align="center" gap="5px">
          <Text {...labelProps}>Final Pickup? : </Text>
          <Text>{pickup?.isFinalPickup ? 'Yes' : 'No'}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
